import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMacysComponent } from './simple-icons-macys.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMacysComponent ],
    exports:      [ SimpleIconsMacysComponent ],
    bootstrap:    []
})
export class SimpleIconsMacysModule {}
